module.exports = __webpack_public_path__ + "img/innovation_hub.90940cea.png";